import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiStrutturaliL1SectionWrapper,
  InspectionInfoForm,
} from 'components';
import { CDAOptions, tipologiaTraveOptions } from 'constants/selectOptions';
import useTabellaRiepilogativa from 'hooks/inspections/useTabellaRiepilogativa';
import { INFO } from 'pages/Inspections/config/info';
import { calculateDifettositaComplessiva } from 'pages/Inspections/CreateInspection/utils/extractDefectivenessInfo';
import TraviForm from './TraviForm';
const TraviSection = ({ selectedIdx }) => {
  const { recalculateTable } = useTabellaRiepilogativa();
  const { watch, setValue, getValues } = useFormContext();

  const mensoleTamponiCampateImpalcatoTableTraviTableWatch = watch(
    `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable`
  );

  const mensoleTamponiCampateImpalcatoTable = watch(
    `mensoleTamponiCampateImpalcatoTable`
  );
  //console.log(spallePileCollegamentiTable, 'spallePileCollegamentiTable');

  const mensoleTamponiCampateToCopy = mensoleTamponiCampateImpalcatoTable?.map(
    el => el.traviTable
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsTravi = item => {
    setValue('traviTableValue', [item]);
    setValue('tipologiaTraveTableValue', item.tipologiaTrave);
  };

  const handleSelectAllClickTravi = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable`
      );
      setSelected(selectedValue);
      setValue('traviTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('traviTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t2a4_tecnicoRilevatoreTravi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t2a4_dataIspezioneTravi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t2a4_elementoCriticoStrutturaTravi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].elementoCriticoStruttura`
      ) || ''
    );
    setValue(
      'l1t2a4_elementoCriticoSismicaTravi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].elementoCriticoSismica`
      ) || ''
    );
    setValue(
      'l1t2a4_condizioneCriticaStrutturaTravi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].condizioneCriticaStruttura`
      ) || ''
    );
    setValue(
      'l1t2a4_condizioneCriticaSismicaTravi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].condizioneCriticaSismica`
      ) || ''
    );
    setValue(
      'l1t2a4_noteGeneraliTravi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues('l1t2a4_tecnicoRilevatoreTravi');
    const dataIspezione = getValues('l1t2a4_dataIspezioneTravi');
    const elementoCriticoStruttura = getValues(
      'l1t2a4_elementoCriticoStrutturaTravi'
    );
    const elementoCriticoSismica = getValues(
      'l1t2a4_elementoCriticoSismicaTravi'
    );
    const condizioneCriticaStruttura = getValues(
      'l1t2a4_condizioneCriticaStrutturaTravi'
    );
    const condizioneCriticaSismica = getValues(
      'l1t2a4_condizioneCriticaSismicaTravi'
    );
    const noteGenerali = getValues('l1t2a4_noteGeneraliTravi');
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].elementoCriticoStruttura`,
      elementoCriticoStruttura
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].elementoCriticoSismica`,
      elementoCriticoSismica
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].condizioneCriticaStruttura`,
      condizioneCriticaStruttura
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].condizioneCriticaSismica`,
      condizioneCriticaSismica
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
    setValue('l1t2a5_trigger', Math.random() * 1000);
    setTimeout(() => {
      recalculateTable();
    }, 0);

    // Gestione calcolo difettosità complessiva nella tabella riepilogativa
    const tableWatch = getValues('riepilogoStrutturaTable');
    const difettositaStrutturaleEffettiva = watch(
      'arbitraryStructuralFoundationalDefectiveness'
    );
    const difettositaSismicaEffettiva = watch('arbitrarySeismicDefectiveness');
    const tabellaRiepilogativa = tableWatch.filter(
      row => row.codice !== 'Difettosità complessiva'
    );
    const { difettositaStrutturale, difettositaSismica } =
      calculateDifettositaComplessiva(tabellaRiepilogativa);
    const updatedTable = tableWatch.map(row => {
      if (row.codice === 'Difettosità complessiva') {
        return {
          ...row,
          difettositaStrutturale,
          difettositaSismica,
        };
      }
      return row;
    });
    setValue('riepilogoStrutturaTable', updatedTable);
    !difettositaStrutturaleEffettiva &&
      setValue(
        'arbitraryStructuralFoundationalDefectiveness',
        difettositaStrutturale
      );
    !difettositaSismicaEffettiva &&
      setValue('arbitrarySeismicDefectiveness', difettositaSismica);
  };

  const handleResetInspection = () => {
    setValue(`l1t2a4_tecnicoRilevatoreTravi`, '');
    setValue(`l1t2a4_dataIspezioneTravi`, null);
    setValue(`l1t2a4_elementoCriticoStrutturaTravi`, '');
    setValue(`l1t2a4_elementoCriticoSismicaTravi`, '');
    setValue(`l1t2a4_condizioneCriticaStrutturaTravi`, '');
    setValue(`l1t2a4_condizioneCriticaSismicaTravi`, '');
    setValue(`l1t2a4_noteGeneraliTravi`, '');
  };

  const dataTraviConfig = {
    columns: {
      codice: { label: 'Cod.' },
      tipologiaTrave: { label: 'Tipologia', format: tipologiaTraveOptions },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      indiceCondizione: { label: 'Indice di condizione' },
      CDAstrutturale: { label: 'Difettosità Str.', format: CDAOptions },
      CDAsismica: { label: 'Difettosità Sis.', format: CDAOptions },
      nrtotali: { label: 'NR' },
      g5totali: { label: 'G=5' },
      pstotali: { label: 'PS' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaTrave: {
        label: 'Tipologia',
        format: tipologiaTraveOptions,
      },
    },
  };

  const mensoleTamponiCampateImpalcatoSelezione = watch(
    'mensoleTamponiCampateImpalcatoSelezione'
  );

  useEffect(() => {
    if (mensoleTamponiCampateImpalcatoSelezione) {
      setSchedaDifettiIndex(undefined);
      setOpenSchedaDifetti(false);
    }
  }, [mensoleTamponiCampateImpalcatoSelezione]);

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiStrutturaliL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'travi'}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoTravi.drawerTitle}
        drawerText={INFO.impalcatoTravi.drawerText}
        singleElementTitle={'trave'}
        tableWatch={mensoleTamponiCampateImpalcatoTableTraviTableWatch}
        tableWatchName={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable`}
        elementForm={
          <TraviForm
            traviFields={
              mensoleTamponiCampateImpalcatoTableTraviTableWatch || []
            }
            selected={selected}
            setSelected={setSelected}
            traviTable={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traviTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoForm
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t2a4_tecnicoRilevatoreTravi'}
            dateName={'l1t2a4_dataIspezioneTravi'}
            elementoCriticoStrutturaName={
              'l1t2a4_elementoCriticoStrutturaTravi'
            }
            elementoCriticoSismicaName={'l1t2a4_elementoCriticoSismicaTravi'}
            condizioneCriticaStrutturaName={
              'l1t2a4_condizioneCriticaStrutturaTravi'
            }
            condizioneCriticaSismicaName={
              'l1t2a4_condizioneCriticaSismicaTravi'
            }
            noteGeneraliName={'l1t2a4_noteGeneraliTravi'}
          />
        }
        tableConfig={dataTraviConfig}
        editRows={editRowsTravi}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickTravi}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={'tipologiaTrave'}
        tableForCopy={mensoleTamponiCampateToCopy}
      />
    </>
  );
};
TraviSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default TraviSection;
